import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";
import authImage from "../../Group 71.png";

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [error, setError] = useState("");
  const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState("");

  const API_BASE = "https://portal.gmacc.co.za/api";
  //const API_BASE = "http://127.0.0.1:8000/api";

  // existing login password toggle
  const [showPassword, setShowPassword] = useState(false);
  // NEW: register password toggles
  const [showRegPassword, setShowRegPassword] = useState(false);
  const [showRegConfirm, setShowRegConfirm] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "GMA Portal";
    document.body.classList.add("auth-body");
    return () => {
      document.body.classList.remove("auth-body");
    };
  }, []);

  const handleToggle = (e) => {
    e.preventDefault();
    setError("");
    setIsLogin(!isLogin);
    setIsForgotPassword(false);
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    setIsForgotPassword(true);
  };

  const handleBackToLogin = (e) => {
    e.preventDefault();
    setIsForgotPassword(false);
    setForgotPasswordSuccess(false);
    setIsLogin(true);
  };

  const normaliseEmail = (value) => value.trim().toLowerCase();
  const validateEmail = (value) => {
    const cleanEmail = normaliseEmail(value);

    if (!cleanEmail) {
      return "Please enter your email address.";
    }

    if (cleanEmail.length > 254) {
      return "Email address is too long.";
    }

    if (cleanEmail.includes("..")) {
      return "Email address cannot contain consecutive dots.";
    }

    const parts = cleanEmail.split("@");

    if (parts.length !== 2) {
      return "Please enter a valid email address.";
    }

    const [localPart, domain] = parts;

    if (!localPart || !domain) {
      return "Please enter a valid email address.";
    }

    if (
      localPart.startsWith(".") ||
      localPart.endsWith(".") ||
      domain.startsWith(".") ||
      domain.endsWith(".")
    ) {
      return "Please enter a valid email address.";
    }

    const emailRegex =
      /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;

    if (!emailRegex.test(cleanEmail)) {
      return "Please enter a valid email address.";
    }

    return "";
  };
  const normaliseMobileNumber = (value) => value.replace(/[\s()-]/g, "");

  const validateSouthAfricanMobile = (value) => {
    const mobile = normaliseMobileNumber(value);

    if (!mobile) {
      return "Please enter your mobile number.";
    }

    /*
     * Accepts:
     * 0821234567
     * +27821234567
     * 27821234567
     *
     * South African mobile prefixes normally begin with 06, 07 or 08.
     */
    const localMobileRegex = /^0[6-8][0-9]{8}$/;
    const internationalMobileRegex = /^(?:\+27|27)[6-8][0-9]{8}$/;

    if (
      !localMobileRegex.test(mobile) &&
      !internationalMobileRegex.test(mobile)
    ) {
      return "Enter a valid South African mobile number, for example 0821234567.";
    }

    return "";
  };
  const normaliseIdNumber = (value) => value.replace(/\D/g, "");

  const isValidDate = (year, month, day) => {
    const date = new Date(year, month - 1, day);

    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    );
  };

  const passesLuhnCheck = (value) => {
    let sum = 0;
    let shouldDouble = false;

    for (let i = value.length - 1; i >= 0; i -= 1) {
      let digit = Number(value[i]);

      if (shouldDouble) {
        digit *= 2;

        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
      shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
  };

  const validateSouthAfricanId = (value) => {
    const id = normaliseIdNumber(value);

    if (!id) {
      return "Please enter your ID number.";
    }

    if (!/^[0-9]{13}$/.test(id)) {
      return "South African ID numbers must contain exactly 13 digits.";
    }

    const yearPart = Number(id.slice(0, 2));
    const month = Number(id.slice(2, 4));
    const day = Number(id.slice(4, 6));

    const currentYear = new Date().getFullYear();
    const currentTwoDigitYear = currentYear % 100;

    const fullYear =
      yearPart <= currentTwoDigitYear ? 2000 + yearPart : 1900 + yearPart;

    if (!isValidDate(fullYear, month, day)) {
      return "The date of birth in the ID number is invalid.";
    }

    const citizenshipDigit = Number(id[10]);

    if (![0, 1].includes(citizenshipDigit)) {
      return "The citizenship digit in the ID number is invalid.";
    }

    if (!passesLuhnCheck(id)) {
      return "The ID number is invalid. Please check all 13 digits.";
    }

    return "";
  };

  const readJsonSafely = async (response) => {
    const contentType = response.headers.get("content-type") || "";

    if (contentType.includes("application/json")) {
      return response.json();
    }

    const text = await response.text();
    return text ? { error: text } : {};
  };

  const storeSession = (data, userEmail) => {
    const currentAccess = Number.parseInt(data.access, 10);
    const accessCount = Number.isFinite(currentAccess) ? currentAccess + 1 : 1;

    localStorage.setItem("token", data.token);
    localStorage.setItem("userProfileId", data.id);
    localStorage.setItem("userEmail", userEmail);
    localStorage.setItem("accInt", String(accessCount));

    if (data.contact_id) {
      localStorage.setItem("contact_id", data.contact_id);
    } else {
      localStorage.removeItem("contact_id");
    }

    return accessCount;
  };

  const updateLoginMetadata = (userId, accessCount) => {
    // Do not block navigation on this non-critical analytics update.
    fetch(`${API_BASE}/update-last-logged-in/`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: userId,
        access: new Date().toISOString(),
        lastDate: accessCount,
      }),
      keepalive: true,
    }).catch(() => {
      // Login remains successful even if metadata update fails.
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Auth form submitted", {
      isLogin,
      isForgotPassword,
      firstName,
      lastName,
      mobileNumber,
      idNumber,
      email,
    });

    if (isSubmitting) return;

    setError("");
    setSuccess("");

    const cleanEmail = normaliseEmail(email);

    const emailValidationError = validateEmail(cleanEmail);

    if (emailValidationError) {
      setError(emailValidationError);
      return;
    }

    if (!cleanEmail) {
      setError("Please enter your email address.");
      return;
    }

    if (!isLogin && !isForgotPassword) {
      if (!firstName.trim()) {
        setError("Please enter your first name.");
        return;
      }

      if (firstName.trim().length < 2) {
        setError("First name must contain at least 2 characters.");
        return;
      }

      if (!lastName.trim()) {
        setError("Please enter your last name.");
        return;
      }

      if (lastName.trim().length < 2) {
        setError("Last name must contain at least 2 characters.");
        return;
      }

      const mobileValidationError = validateSouthAfricanMobile(mobileNumber);

      if (mobileValidationError) {
        setError(mobileValidationError);
        return;
      }

      const idValidationError = validateSouthAfricanId(idNumber);

      if (idValidationError) {
        setError(idValidationError);
        return;
      }

      const registrationEmailError = validateEmail(cleanEmail);

      if (registrationEmailError) {
        setError(registrationEmailError);
        return;
      }

      if (password.length < 8) {
        setError("Password must contain at least 8 characters.");
        return;
      }

      if (!/[A-Z]/.test(password)) {
        setError("Password must contain at least one uppercase letter.");
        return;
      }

      if (!/[a-z]/.test(password)) {
        setError("Password must contain at least one lowercase letter.");
        return;
      }

      if (!/[0-9]/.test(password)) {
        setError("Password must contain at least one number.");
        return;
      }

      if (!confirmPassword) {
        setError("Please confirm your password.");
        return;
      }

      if (password !== confirmPassword) {
        setError("Passwords do not match.");
        return;
      }
    }
    setIsSubmitting(true);

    try {
      if (isForgotPassword) {
        const response = await fetch(`${API_BASE}/forgot-password/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: cleanEmail,
          }),
        });

        const data = await readJsonSafely(response);

        /*
         * Display the same result even when no account exists.
         * This avoids exposing whether a particular email is registered.
         */
        if (!response.ok && response.status >= 500) {
          throw new Error(
            data.error || "The reset request could not be completed.",
          );
        }

        setForgotPasswordSuccess(true);
        return;
      }

      if (isLogin) {
        const response = await fetch(`${API_BASE}/login/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: cleanEmail,
            password,
          }),
        });

        const data = await readJsonSafely(response);

        if (!response.ok) {
          throw new Error(data.error || "Invalid email or password.");
        }

        const accessCount = storeSession(data, cleanEmail);

        updateLoginMetadata(data.id, accessCount);

        navigate("/user-portal", { replace: true });
        return;
      }

      /*
       * Registration no longer calls /contact/find/.
       * register/ already performs this lookup server-side.
       */
      const response = await fetch(`${API_BASE}/register/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstname: firstName.trim(),
          lastname: lastName.trim(),
          mobilenumber: normaliseMobileNumber(mobileNumber),
          email: cleanEmail,
          password,
          id_number: normaliseIdNumber(idNumber),
        }),
      });

      const data = await readJsonSafely(response);

      if (!response.ok) {
        throw new Error(
          data.error ||
            "Registration could not be completed. Please try again.",
        );
      }

      /*
       * The improved register endpoint returns a ready-to-use session,
       * removing the extra automatic-login request.
       */
      if (data.token && data.id) {
        const accessCount = storeSession(data, cleanEmail);

        updateLoginMetadata(data.id, accessCount);

        navigate("/user-portal", { replace: true });
        return;
      }

      /*
       * Compatibility fallback while frontend/backend deployments overlap.
       * Remove after the updated backend is deployed everywhere.
       */
      const loginResponse = await fetch(`${API_BASE}/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: cleanEmail,
          password,
        }),
      });

      const loginData = await readJsonSafely(loginResponse);

      if (!loginResponse.ok) {
        setIsLogin(true);
        setSuccess(
          "Registration succeeded. Please log in with your new account.",
        );
        setPassword("");
        setConfirmPassword("");
        return;
      }

      const accessCount = storeSession(loginData, cleanEmail);

      updateLoginMetadata(loginData.id, accessCount);

      navigate("/user-portal", { replace: true });
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "The request could not be completed.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Live registration validation messages
  const emailFieldError =
    !isLogin && !isForgotPassword && email.trim() ? validateEmail(email) : "";

  const mobileFieldError =
    !isLogin && !isForgotPassword && mobileNumber.trim()
      ? validateSouthAfricanMobile(mobileNumber)
      : "";

  const idFieldError =
    !isLogin && !isForgotPassword && idNumber.trim()
      ? validateSouthAfricanId(idNumber)
      : "";

  const passwordFieldError =
    !isLogin && !isForgotPassword && password
      ? password.length < 8
        ? "Password must contain at least 8 characters."
        : !/[A-Z]/.test(password)
          ? "Password must contain at least one uppercase letter."
          : !/[a-z]/.test(password)
            ? "Password must contain at least one lowercase letter."
            : !/[0-9]/.test(password)
              ? "Password must contain at least one number."
              : ""
      : "";

  return (
    <div className={styles.page}>
      <div className={styles.authFrame}>
        {/* left image */}
        <div className={styles.authMedia} aria-hidden="true"></div>

        {/* right panel / form */}
        <div className={styles.authPanel}>
          <form
            className={styles.formContainer}
            onSubmit={handleSubmit}
            noValidate
          >
            <img
              src={logoimage}
              alt="Gauteng Management Agents"
              className={styles.logoImage}
            />

            <h1 className={styles.formTitle}>
              {isForgotPassword
                ? "FORGOT PASSWORD"
                : isLogin
                  ? "LOGIN"
                  : "REGISTER"}
            </h1>

            {isForgotPassword ? (
              forgotPasswordSuccess ? (
                <>
                  <p className={styles.successText}>
                    If the email exists, a reset link has been sent.
                  </p>
                  <p className={styles.backToLoginText}>
                    <a
                      href="#"
                      onClick={handleBackToLogin}
                      className={styles.link}
                    >
                      Return to Login
                    </a>
                  </p>
                </>
              ) : (
                <>
                  <div className={styles.inputGroup}>
                    <input
                      type="email"
                      inputMode="email"
                      autoComplete="email"
                      spellCheck={false}
                      autoCapitalize="none"
                      className={styles.input}
                      placeholder="Email"
                      value={email}
                      maxLength={254}
                      onChange={(e) => setEmail(e.target.value)}
                      onBlur={(e) => setEmail(normaliseEmail(e.target.value))}
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className={styles.primaryButton}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Sending..." : "Reset"}
                  </button>
                  <p className={styles.backToLoginText}>
                    <a
                      href="#"
                      onClick={handleBackToLogin}
                      className={styles.link}
                    >
                      Back to Login
                    </a>
                  </p>
                </>
              )
            ) : isLogin ? (
              <>
                {/* EMAIL */}
                <div className={styles.inputGroup}>
                  <label className={styles.inputLabel}>Email</label>
                  <div className={styles.inputShell}>
                    <input
                      type="email"
                      inputMode="email"
                      autoComplete="email"
                      spellCheck={false}
                      autoCapitalize="none"
                      className={styles.input}
                      placeholder="Email"
                      value={email}
                      maxLength={254}
                      onChange={(e) => setEmail(e.target.value)}
                      onBlur={(e) => setEmail(normaliseEmail(e.target.value))}
                      required
                    />
                  </div>
                </div>

                {/* PASSWORD */}
                <div className={styles.inputGroup}>
                  <label className={styles.inputLabel}>Password</label>
                  <div className={styles.inputShell}>
                    <input
                      type={showPassword ? "text" : "password"}
                      className={styles.input}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className={styles.passwordToggle}
                      onClick={() => setShowPassword((p) => !p)}
                      aria-label="Toggle password visibility"
                    >
                      <svg viewBox="0 0 24 24">
                        <path d="M12 5c-5 0-9 4.5-9 7s4 7 9 7 9-4.5 9-7-4-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z" />
                      </svg>
                    </button>
                  </div>
                </div>

                {success && (
                  <p className={styles.successText} role="status">
                    {success}
                  </p>
                )}

                {error && (
                  <p className={styles.errorText} role="alert">
                    {error}
                  </p>
                )}

                <div className={styles.inlineLinks}>
                  <a
                    href="#"
                    onClick={handleForgotPassword}
                    className={styles.link}
                  >
                    Forgot Password?
                  </a>
                  <a href="https://www.gmacc.co.za/" className={styles.link}>
                    Back Home
                  </a>
                </div>

                <button
                  type="submit"
                  className={styles.primaryButton}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Logging in..." : "Login"}
                </button>

                <p className={styles.footerText}>
                  Don&apos;t have an account?{" "}
                  <a href="#" onClick={handleToggle} className={styles.link}>
                    Register Here
                  </a>
                </p>
              </>
            ) : (
              <>
                {/* REGISTER */}
                <div className={styles.row}>
                  <div className={styles.inputGroup}>
                    <div className={styles.inputShell}>
                      <input
                        type="text"
                        className={styles.input}
                        placeholder="First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className={styles.inputGroup}>
                    <div className={styles.inputShell}>
                      <input
                        type="text"
                        className={styles.input}
                        placeholder="Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className={styles.inputGroup}>
                  <div className={styles.inputShell}>
                    <input
                      type="tel"
                      inputMode="tel"
                      autoComplete="tel"
                      className={styles.input}
                      placeholder="Mobile Number, e.g. 0821234567"
                      value={mobileNumber}
                      maxLength={16}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (/^[0-9+\s()-]*$/.test(value)) {
                          setMobileNumber(value);
                        }
                      }}
                      required
                    />
                  </div>

                  {mobileFieldError && (
                    <p className={styles.errorText} role="alert">
                      {mobileFieldError}
                    </p>
                  )}
                </div>

                <div className={styles.inputGroup}>
                  <div className={styles.inputShell}>
                    <input
                      type="text"
                      inputMode="numeric"
                      autoComplete="off"
                      className={styles.input}
                      placeholder="13-digit South African ID Number"
                      value={idNumber}
                      maxLength={13}
                      onChange={(e) => {
                        setIdNumber(
                          e.target.value.replace(/\D/g, "").slice(0, 13),
                        );
                      }}
                      required
                    />
                  </div>

                  {idFieldError && (
                    <p className={styles.errorText} role="alert">
                      {idFieldError}
                    </p>
                  )}
                </div>

                <div className={styles.inputGroup}>
                  <div className={styles.inputShell}>
                    <input
                      type="email"
                      inputMode="email"
                      autoComplete="email"
                      spellCheck={false}
                      autoCapitalize="none"
                      className={styles.input}
                      placeholder="Email"
                      value={email}
                      maxLength={254}
                      onChange={(e) => setEmail(e.target.value)}
                      onBlur={(e) => setEmail(normaliseEmail(e.target.value))}
                      required
                    />
                  </div>

                  {emailFieldError && (
                    <p className={styles.errorText} role="alert">
                      {emailFieldError}
                    </p>
                  )}
                </div>

                <div className={styles.row}>
                  <div className={styles.inputGroup}>
                    <div className={styles.inputShell}>
                      <input
                        type={showRegPassword ? "text" : "password"}
                        className={styles.input}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <button
                        type="button"
                        className={styles.passwordToggle}
                        onClick={() => setShowRegPassword((p) => !p)}
                        aria-label="Toggle password visibility"
                      >
                        <svg viewBox="0 0 24 24">
                          <path d="M12 5c-5 0-9 4.5-9 7s4 7 9 7 9-4.5 9-7-4-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className={styles.inputGroup}>
                    <div className={styles.inputShell}>
                      <input
                        type={showRegConfirm ? "text" : "password"}
                        className={styles.input}
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      <button
                        type="button"
                        className={styles.passwordToggle}
                        onClick={() => setShowRegConfirm((p) => !p)}
                        aria-label="Toggle confirm password visibility"
                      >
                        <svg viewBox="0 0 24 24">
                          <path d="M12 5c-5 0-9 4.5-9 7s4 7 9 7 9-4.5 9-7-4-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                {passwordFieldError && (
                  <p className={styles.errorText} role="alert">
                    {passwordFieldError}
                  </p>
                )}

                {confirmPassword && password !== confirmPassword && (
                  <p className={styles.errorText} role="alert">
                    Passwords do not match.
                  </p>
                )}
                {success && (
                  <p className={styles.successText} role="status">
                    {success}
                  </p>
                )}

                {error && (
                  <p className={styles.errorText} role="alert">
                    {error}
                  </p>
                )}

                <button
                  type="submit"
                  className={styles.primaryButton}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Creating..." : "Create"}
                </button>
                <p className={styles.footerText}>
                  Already Registered?{" "}
                  <a href="#" onClick={handleToggle} className={styles.link}>
                    Log in Here
                  </a>
                </p>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
